export const BANK_ACCOUNT_TYPES: { [key: string]: string } = {
  checkings: 'Conta Corrente',
  savings: 'Poupança'
}
